export class Settings {

    static instance: Settings

    static  getInstance() {
        if (!Settings.instance) {
            Settings.instance = new Settings();
        }
        return Settings.instance;
    }

    public getScrollSpace() {
        return (document.querySelector('body').clientWidth <= 640) ? 65 : 100;
    }

}
